import { formatDate, formatTimeInMoscow } from '../../../../../utils';

/**
 * «Сегодня в HH:MM» или календарная дата в Москве.
 * referenceNow — тот же момент, что и для formatDate при SSR/гидрации.
 */
export const getDate = (date: Date, referenceNow?: Date) => {
  const dateFormatted = formatDate(date, { dayNames: ['сегодня'], referenceNow });

  return dateFormatted === 'сегодня' ? `${dateFormatted} в ${formatTimeInMoscow(date)}` : dateFormatted;
};
